export const showCurrencyAsCode = ["COP"];
